(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bamboo-capping-add-on"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    var addOn = document.getElementById('BambooCappingAddOn');
    if (!addOn || window.sessionStorage.getItem('bamboo-capping-add-on-dismissed') === 'true') return;

    addOn.querySelector('.bamboo-capping-add-on__dismiss').addEventListener('click', function () {
      window.sessionStorage.setItem('bamboo-capping-add-on-dismissed', 'true');
      addOn.remove();
    });
  });
  } catch(e) { console.error(e); }
})();

})();
